import React from 'react';
import { graphql } from "react-apollo";
import { compose, lifecycle, pure } from 'recompose';
import {
  Col,
  Nav,
  NavItem,
  Row,
  Tab
} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import Queries from "../../../queries/queries2";

import gql from "graphql-tag";

const toValidateNotifications = (
  <Tooltip id="toCheck">
    <FormattedMessage id="ids_toCheck" />
  </Tooltip>
);
const toQualifyNotifications = (
  <Tooltip id="toQualify">
    <FormattedMessage id="ids_toQualify" />
  </Tooltip>
);
const missingExpenseInvoiceNotifications = (
  <Tooltip id="missingAttachment">
    <FormattedMessage id="ids_missingAttachment" />
  </Tooltip>
);


const BANK_TRANSACTION_CREATED_SUBSCRIPTION = gql`
  subscription onBankTransactionCreated(
    $companyId: ID!
    $bankAccountId: ID!
  ) {
    bankTransactionCreated(
      companyId: $companyId
      bankAccountId: $bankAccountId
    ) {
      id
      status
      bankTransactionLines(orderBy: numLine_ASC) {
        id
        category {
          id
        }
        tiers {
          id
        }
      }
      attachment{
        id
      }
      isDeleted    
    }
  }
`;

const BANK_TRANSACTION_UPDATED_SUBSCRIPTION = gql`
  subscription onBankTransactionUpdated(
    $companyId: ID!
    $bankAccountId: ID!
  ) {
    bankTransactionUpdated(
      companyId: $companyId
      bankAccountId: $bankAccountId
    ) {
      id
      status
      bankTransactionLines(orderBy: numLine_ASC) {
        id
        category {
          id
        }
        tiers {
          id
        }
      }
      attachment{
        id
      }
      isDeleted    
    }
  }
`;



const data = graphql(Queries.GET_BANK_TRANSACTIONS_COUNT);

const transactionAutoQualifCount = graphql(
  Queries.GET_BANK_ACCOUNT_AUTOQUALIF_TRANSACTION_COUNT,
  {
    name: "transactionAutoQualifCount",
    options: ({ bankAccountId }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: { bankAccountId: bankAccountId }
      };
    }
  }
);

const transactionMissingExpenseInvoiceCount = graphql(
  Queries.GET_BANK_ACCOUNT_WITHOUT_EXPENSEINVOICE_TRANSACTION_COUNT,
  {
    name: "transactionMissingExpenseInvoiceCount",
    options: ({ bankAccountId }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: { bankAccountId: bankAccountId }
      };
    }
  }
);

// const transactionWithoutExpenseInvoiceCount = graphql(
//   Queries.GET_BANK_ACCOUNT_AUTOQUALIF_TRANSACTION_COUNT,
//   {
//     name: "transactionWithoutExpenseInvoiceCount",
//     options: ({ bankAccountId }) => {
//       return {
//         fetchPolicy: "cache-and-network",
//         variables: { bankAccountId: bankAccountId }
//       };
//     }
//   }
// );


const componentLifecycle = lifecycle({
  componentDidMount() {
    // console.log("104 - ExpenseListContainer.componentDidMount", this.props);
    if (!this.props.data) return;

    // BankTransactionCreated
    this.unsubscribeBankTransactionCreated = this.props.data.subscribeToMore({
      document: BANK_TRANSACTION_CREATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId,
        bankAccountId: this.props.bankAccountId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.props.data.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // BankTransactionUpdated
    this.unsubscribeBankTransactionUpdated = this.props.data.subscribeToMore({
      document: BANK_TRANSACTION_UPDATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId,
        bankAccountId: this.props.bankAccountId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.props.data.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });
    return;
  },

  componentWillUnmount() {
    this.unsubscribeBankTransactionCreated();
    this.unsubscribeBankTransactionUpdated();
  }
});


let PaymentTabs = ({
  data: {
    allCount,
    toQualifyCount
  },
  transactionAutoQualifCount,
  transactionMissingExpenseInvoiceCount,
  handleTabSelect,
  tabSelected
}) => {

  // console.log("transactionAutoQualifCount=", transactionAutoQualifCount);
  if (allCount && toQualifyCount) {

    return (
      <Tab.Container onSelect={(element) => handleTabSelect({
        name: element,
        count: element === "all" ? allCount.count : toQualifyCount.count
      })}
        id="tabs-simple" defaultActiveKey={tabSelected.name} activeKey={tabSelected.name}>
        <Row className="clearfix">
          <Col sm={12}>
            <Nav bsStyle="tabs" >
              <NavItem eventKey="all">
                <FormattedMessage id='ids_all_listTab' />
                {/* {" "}
                <span className="badge">{allCount && allCount.count}</span> */}
              </NavItem>
              <NavItem eventKey="toDo" >
                <FormattedMessage id="TODO" />
                {" "}

                {transactionAutoQualifCount._bankTransactionsMeta &&
                  transactionAutoQualifCount._bankTransactionsMeta.count > 0 && (
                    <OverlayTrigger placement="top" overlay={toValidateNotifications}>
                      <span className="badgeGreen">
                        {transactionAutoQualifCount._bankTransactionsMeta &&
                          transactionAutoQualifCount._bankTransactionsMeta.count}
                      </span>
                    </OverlayTrigger>

                  )}
                {" "}
                {toQualifyCount &&
                  toQualifyCount.count > 0 && (
                    <OverlayTrigger placement="top" overlay={toQualifyNotifications}>
                      <span className="badgeRed">
                        {toQualifyCount && toQualifyCount.count}
                      </span>
                    </OverlayTrigger>
                  )}
              </NavItem>

              <NavItem eventKey="toJustify" >
                <FormattedMessage id="ids_toJustify" />
                {transactionMissingExpenseInvoiceCount._bankTransactionsMeta &&
                  transactionMissingExpenseInvoiceCount._bankTransactionsMeta.count > 0 && (
                    <OverlayTrigger placement="top" overlay={missingExpenseInvoiceNotifications}>
                      <span className="badgeRed">
                        {transactionMissingExpenseInvoiceCount._bankTransactionsMeta &&
                          transactionMissingExpenseInvoiceCount._bankTransactionsMeta.count}
                      </span>
                    </OverlayTrigger>
                  )}
              </NavItem>

            </Nav>
          </Col>
        </Row>
      </Tab.Container>
    )
  }
  return (
    <Row className="clearfix">
      <Col sm={12}>
        <Nav bsStyle="tabs">
          <NavItem eventKey="toDo">
            <FormattedMessage id='TODO' />
            {" "}
            <span className="badge">{toQualifyCount && toQualifyCount.count}</span>
          </NavItem>
          <NavItem eventKey="all">
            <FormattedMessage id='ids_all_listTab'
              description="payment list tab all"
              defaultMessage="Tous" />
            {" "}
            <span className="badge">{allCount && allCount.count}</span>
          </NavItem>
        </Nav>
      </Col>
    </Row>
  )
}


PaymentTabs = compose(
  data,
  transactionAutoQualifCount,
  transactionMissingExpenseInvoiceCount,
  componentLifecycle,
  pure
)(PaymentTabs)

export default PaymentTabs;
